import { render } from "./CardioQnrView.vue?vue&type=template&id=3920257a&scoped=true"
import script from "./CardioQnrView.vue?vue&type=script&lang=js"
export * from "./CardioQnrView.vue?vue&type=script&lang=js"

import "./CardioQnrView.vue?vue&type=style&index=0&id=3920257a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3920257a"]])

export default __exports__